import { render, staticRenderFns } from "./DepositConcentration.vue?vue&type=template&id=6b8ed89a&scoped=true"
import script from "./DepositConcentration.vue?vue&type=script&lang=js"
export * from "./DepositConcentration.vue?vue&type=script&lang=js"
import style0 from "./DepositConcentration.vue?vue&type=style&index=0&id=6b8ed89a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8ed89a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VRow,VTooltip})
